/**
 * The one place the public origin is decided. Canonicals, JSON-LD, the sitemap
 * and robots all build absolute URLs from here, so a staging deploy that sets
 * NEXT_PUBLIC_APP_URL never advertises production URLs (and vice versa).
 */
export const SITE_URL = (process.env.NEXT_PUBLIC_APP_URL || 'https://roomtreatment.diy').replace(/\/$/, '');

export const SITE_NAME = 'roomtreatment.diy';

/** Absolute URL for a site path. `absoluteUrl('/')` is the bare origin. */
export function absoluteUrl(path: string): string {
  if (path === '/' || path === '') return SITE_URL;
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
}
